import { v7 as Uuid } from 'uuid';

export const createHeaders = (additionalHeaders = {}) => {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Correlation-ID': Uuid(),
    ...additionalHeaders,
  };
};

export const handleResponse = async response => {
  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    // Kein JSON-Body (z.B. bei 204)
  }
  return {
    success: response.ok,
    status: response.status,
    data,
  };
};

// nur bei Netzwerk- oder CORS-Fehlern relevant, wenn keinerlei response zurückkommt
// 4xx, und 5xx werfen keine exception, sondern werden normal von handleResponse verarbeitet
export const handleException = error => {
  return {
    success: false,
    status: -1,
    data: error.message || String(error),
  };
};
